module.exports = __webpack_public_path__ + "static/media/car4.47941bb0.jpg";